module.exports = __webpack_public_path__ + "static/media/custom-active-code.a7df838b.png";